class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    const wasActive = this.notification.classList.contains('active');
    this.notification.classList.add('animate', 'active');

    // Fire view_cart once per notification-open (NOT every render).
    if (!wasActive) {
      try { this.fireViewCart(); } catch (e) {}
    }

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  // GA4 view_cart — fires when the cart-notification (mini-cart) pops open.
  // Dual-fires to gtag + dataLayer. Wrapped to never break the UI.
  fireViewCart() {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then((res) => (res.ok ? res.json() : null))
        .then((cart) => {
          if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;
          const currency = cart.currency || 'USD';
          const value = (cart.total_price || 0) / 100;
          const items = cart.items.map((it, i) => ({
            item_id: String(it.product_id || ''),
            item_variant_id: String(it.variant_id || ''),
            item_name: it.product_title || it.title || '',
            item_variant: it.variant_title || '',
            price: (it.price || 0) / 100,
            quantity: it.quantity || 1,
            index: i
          }));
          const payload = { items, currency, value };
          try { if (window.gtag) gtag('event', 'view_cart', payload); } catch (e) {}
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'view_cart', ecommerce: { items, currency, value } });
          } catch (e) {}
        })
        .catch(() => {});
    } catch (e) {}
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target) return;
      // Null-safe: a section that renders nothing (e.g. the vibe upsell with no
      // match) must never break the core cart render (bubble, product, button).
      const html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      target.innerHTML = html == null ? '' : html;
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-upsell',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const found = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return found ? found.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
